import {
    FilledInput,
    FormControl,
    FormHelperText,
    InputAdornment,
    InputLabel,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import IconButton from '@mui/material/IconButton'
import { VisibilityOff } from '@mui/icons-material'
import Visibility from '@mui/icons-material/Visibility'
import { $Gray75, $White } from '@Styles/colors'
import clsx from 'clsx'
import { useState } from 'react'
import './PasswordField.scss'

const useStylesReddit = makeStyles(() => ({
    root: {
        width: '100%',

        '& .MuiFilledInput-input': {
            padding: '22px 12px 9px',
            fontWeight: 'bold',
            fontSize: 16,
        },
        '& .MuiFilledInput-root.Mui-disabled': {
            '&:hover': {
                cursor: 'no-drop',
            },
            backgroundColor: '#E0E0E0',
        },
        '& .MuiFilledInput-root': {
            background: $White,
            border: '1px solid #E4E9ED',
            borderRadius: 10,
            transition: '0.2s',

            '& .Mui-disabled': {
                '&:hover': {
                    cursor: 'no-drop',
                },
            },
        },
        '& .MuiFilledInput-root.Mui-focused': {
            backgroundColor: '#fff',
            transition: '0.2s',
            boxShadow: 'none',
            borderColor: '#BF0B30 !important',
            outline: 'none',
            borderRadius: 10,

            // color: $WhiteSmoke,
        },
        '& .MuiInputLabel-root': {
            color: $Gray75,
        },
    },
}))

interface IPasswordField {
    value: any
    onChange: any
    error?: boolean
    helperText?: string
    inputRef?: any
    label?: string
    id?: string
    className?: string
    disabled?: boolean
    onKeyPress?: any
}

function PasswordField(props: IPasswordField) {
    // core section
    const {
        value,
        onChange,
        error,
        helperText,
        inputRef,
        label,
        id = 'password-field',
        className,
        disabled = false,
        onKeyPress,
    } = props
    const classes = useStylesReddit()

    // states section
    const [inputType, setInputType] = useState('password')

    const handleClickShowPassword = () => {
        setInputType((prevState) =>
            prevState === 'text' ? 'password' : 'text'
        )
    }

    return (
        <FormControl
            className={clsx(classes.root, className, 'password-field-input')}
            variant="filled"
        >
            <InputLabel htmlFor={id}>{label}</InputLabel>
            <FilledInput
                id={id}
                type={inputType}
                value={value}
                onChange={onChange}
                disableUnderline
                error={error}
                inputRef={inputRef}
                disabled={disabled}
                fullWidth
                endAdornment={
                    <InputAdornment
                        position="end"
                        className="position-absolute"
                    >
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                            size="large"
                        >
                            {inputType === 'text' ? (
                                <Visibility />
                            ) : (
                                <VisibilityOff />
                            )}
                        </IconButton>
                    </InputAdornment>
                }
                onKeyPress={onKeyPress}
            />
            <FormHelperText error={error}>{helperText}</FormHelperText>
        </FormControl>
    )
}

export default PasswordField
